import Draggable from "components/Dnd/Draggable";
import IconCard from "./IconCard";
import IfElseWorkflowCard from "./IfElseWorkflowCard";
import { WorkflowLine } from "./WorkflowElements";

const WorkflowCard = ({
  action,
  actions,
  errors,
  isTrigger,
  openCreateDrawer,
  openEditDrawer,
  optionsMenu,
  disableDnd = false,
  childCard = false,
}) => {
  if (isTrigger) {
    return (
      <div style={{ width: "100%", maxWidth: 500 }}>
        <IconCard
          icon={action?.Icon}
          name={action?.Name}
          description={action?.Description}
          vectorIcon={action?.VectorIcon}
          isTrigger={isTrigger}
          optionsMenu={optionsMenu}
          onClick={isTrigger ? null : openEditDrawer}
        />
        <WorkflowLine />
      </div>
    );
  }

  if (action?.Type === "if-else-case")
    return (
      <>
        <IfElseWorkflowCard
          action={action}
          actions={actions}
          errors={errors}
          openCreateDrawer={openCreateDrawer}
          openEditDrawer={openEditDrawer}
        />
      </>
    );

  errors = errors?.[action.id];

  return (
    <>
      <Draggable
        id={action.id}
        data={{ action }}
        disabled={disableDnd}
        useDragHandle
        disableTransform
        styles={{ minWidth: childCard ? "100%" : 500 }}
        childComponent={(dragInfo, dragHandle) => (
          <div style={{ width: "100%", maxWidth: 500 }}>
            <IconCard
              optionsMenu={true}
              icon={action?.Icon}
              name={action?.Name}
              description={action?.Description}
              isTrigger={isTrigger}
              index={action.Index}
              onClick={
                isTrigger ? null : () => openEditDrawer(action.id, null, action)
              }
              vectorIcon={action?.VectorIcon}
              useDragHandle={{
                listeners: dragHandle.listeners,
                attributes: dragHandle.attributes,
              }}
              isSelected={dragInfo.isOver && !dragInfo.isOverSame}
              isDisabled={dragInfo.isDragging}
              errors={errors}
            />
          </div>
        )}
      />
      <WorkflowLine />
    </>
  );
};

export default WorkflowCard;
